.modalRoot {
  overflow-y: auto;
  padding-inline: var(--pgm-sys-spacing-4);
  background-color: rgb(0 0 0 / 52%);
}

.modalRoot .modalDialog {
  width: calc(100% - (2 * var(--pgm-sys-spacing-4)));
  max-width: 760px;
  margin: var(--pgm-sys-spacing-6) auto;
}

.modalContent {
  display: flex;
  max-height: calc(100vh - (2 * var(--pgm-sys-spacing-6)));
  flex-direction: column;
  overflow: hidden;
  pointer-events: auto;
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: var(--pgm-sys-spacing-4);
  background-color: var(--pgm-sys-color-surface);
  box-shadow: var(--pgm-sys-elevation-level3);
  color: var(--pgm-sys-color-on-surface);
}

.modalHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--pgm-sys-spacing-6);
}

.title {
  margin: var(--pgm-sys-spacing-0);
  color: var(--pgm-sys-color-on-surface);
}

.modalBody {
  overflow-y: auto;
  padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6);
}

.instructions {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  margin: var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-4);
  color: var(--pgm-sys-color-on-surface);
}

.instructionTitle {
  margin: 0;
  color: var(--pgm-sys-color-on-surface);
}

.instructionList {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  margin: 0;
  padding-inline-start: var(--pgm-sys-spacing-6);
  color: var(--pgm-sys-color-on-surface);
}

.instructionList li {
  padding-inline-start: var(--pgm-sys-spacing-1);
}

.browserNotice {
  display: flex;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-2);
  border-radius: var(--pgm-sys-spacing-2);
  background-color: var(--pgm-sys-color-tertiary-container);
  color: var(--pgm-sys-color-on-tertiary-container);
}

.noticeIcon {
  flex: 0 0 var(--pgm-sys-spacing-5);
  width: var(--pgm-sys-spacing-5);
  height: var(--pgm-sys-spacing-5);
  font-size: var(--pgm-sys-spacing-5);
  line-height: var(--pgm-sys-spacing-5);
}

.noticeText {
  flex: 1;
}

.modalCloseButton {
  --md-icon-button-hover-state-layer-opacity: 0.08;
  --md-icon-button-pressed-state-layer-opacity: 0.12;

  cursor: pointer;
}

.modalCloseButton {
  --md-icon-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-hover-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-pressed-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-icon-button-pressed-state-layer-color: var(--pgm-sys-color-on-surface-variant);
}

.attendantsList {
  margin-top: var(--pgm-sys-spacing-4);
}

.attendantItem {
  display: flex;
  min-height: 82px;
  align-items: center;
  gap: var(--pgm-sys-spacing-3);
  padding: var(--pgm-sys-spacing-4);
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
}

.attendantItem:last-child {
  border-bottom: 0;
}

.attendantAvatar {
  display: flex;
  width: var(--pgm-sys-spacing-14);
  height: var(--pgm-sys-spacing-14);
  flex: 0 0 var(--pgm-sys-spacing-14);
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--pgm-sys-color-surface-container);
  color: var(--pgm-sys-color-on-surface);
  font-family: var(--pgm-sys-typescale-label-large-font);
  font-size: var(--pgm-sys-typescale-label-large-size);
  font-weight: var(--pgm-sys-typescale-label-large-weight);
  line-height: var(--pgm-sys-typescale-label-large-line-height);
}

.attendantInformation {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--pgm-sys-spacing-1);
}

.statusBadge {
  display: inline-flex;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
  padding: 2px var(--pgm-sys-spacing-2);
  border-radius: 9999px;
}

.statusAvailable {
  background-color: color-mix(
    in srgb,
    var(--pgm-sys-color-success) 12%,
    var(--pgm-sys-color-surface)
  );
}

.statusBusy {
  background-color: var(--pgm-sys-color-error-container);
  color: var(--pgm-sys-color-on-error-container);
}

.statusDot {
  width: var(--pgm-sys-spacing-2);
  height: var(--pgm-sys-spacing-2);
  border-radius: 50%;
  background-color: var(--pgm-sys-color-error);
}

.statusAvailable .statusDot {
  background-color: var(--pgm-sys-color-success);
}

.attendantName {
  margin: var(--pgm-sys-spacing-0);
  color: var(--pgm-sys-color-on-surface);
  overflow-wrap: anywhere;
}

.callButton {
  --md-filled-tonal-button-container-color: var(--pgm-sys-color-secondary-container);
  --md-filled-tonal-button-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-icon-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-hover-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-hover-icon-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-hover-state-layer-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-focus-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-focus-icon-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-pressed-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-pressed-icon-color: var(--pgm-sys-color-on-secondary-container);
  --md-filled-tonal-button-pressed-state-layer-color: var(--pgm-sys-color-on-secondary-container);
}

.callIcon {
  font-variation-settings: "FILL" 1;
}

.callButton,
.busyButton {
  --pgm-button-label-font: var(--pgm-sys-typescale-title-medium-font);
  --pgm-button-label-line-height: var(--pgm-sys-typescale-title-medium-line-height);
  --pgm-button-label-size: var(--pgm-sys-typescale-title-medium-size);
  --pgm-button-label-tracking: var(--pgm-sys-typescale-title-medium-tracking);
  --pgm-button-label-weight: var(--pgm-sys-typescale-title-medium-weight);

  flex-shrink: 0;
}

.contributorConsultModal {
  width: 900px;
  max-width: 100%;
  margin-top: 60px;
}

@media (max-width: 599px) {
  .modalRoot {
    padding-inline: var(--pgm-sys-spacing-2);
  }

  .modalRoot .modalDialog {
    width: 100%;
    margin-block: var(--pgm-sys-spacing-2);
  }

  .modalContent {
    max-height: calc(100vh - (2 * var(--pgm-sys-spacing-2)));
  }

  .attendantItem {
    align-items: flex-start;
  }

  .attendantItem > :last-child {
    margin-top: var(--pgm-sys-spacing-2);
  }
}
